import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const timeElapsed = Date.now();
const today = new Date(timeElapsed);

const styles = StyleSheet.create({
    fragmentContainer: {
        width: '100%',
        flexDirection: 'row',
        height: 50,
        border: '1px solid #000000'
    },
    columnContainer: {
        borderRight: '1px solid #000000',
        padding: '2px',
        width: '75%'
    },
    label: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    content: {
        fontSize: 12
    },
    dateContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        borderLeft: '1px solid #000000',
        width: '25%'
    },
    date: {
        fontSize: 12,
        fontStyle: 'bold'
    }
});


  const DossieTitle = ({title}) => (
    <Fragment>
        <View style={styles.fragmentContainer}>
            <View style={styles.columnContainer}>
                <Text key={'name'} style={styles.label}>Nome: {title.name}</Text>
                <Text key={'fone'} style={styles.label}>Telefone: {title.fone}</Text>
                <Text key={'cpf_cnpj'} style={styles.label}>CPF/CNPJ: {title.cpf_cnpj}</Text>
            </View>
            <View style={styles.dateContainer}>
                <Text style={styles.date}>{`Data: ${today.toLocaleDateString()}`}</Text>
            </View>
        </View>
    </Fragment>
  );
  
  export default DossieTitle